/**
 * Validates that the input contains a German postal code (5 digits) followed by a city name.
 * Examples of valid input: "10115 Berlin", "40210 Düsseldorf"
 * Examples of invalid input: "123", "Berlin", "1011 Hamburg
 */
export function germanPostalCodeCheck(value: string | null | undefined) {
	const pattern = /^\s*$|^\d{5}\s+\S+/;
	const v = (value ?? '').trim();
	return pattern.test(v);
}
